import { defineMessage } from 'react-intl';

export const urbania: SiteMenus = {
    menuHeader: [
        {
            id: 'boutique',
            label: 'Boutique',
            href: 'https://boutique.urbania.ca',
            icon: 'shopping_cart',
            external: true,
        },
    ],
    menuFooter: [
        [
            {
                id: 'a-propos',
                href: '/a-propos',
                label: 'À propos',
            },
            {
                id: 'contact',
                href: '/contact',
                label: 'Contact',
            },
            {
                id: 'publicite',
                href: '/publicite',
                label: 'Publicité',
            },
        ],
        [
            {
                id: 'conditions',
                href: '/conditions-dutilisation',
                label: 'Conditions d’utilisation',
            },
            {
                id: 'privacy',
                href: 'https://www.iubenda.com/privacy-policy/49318682',
                label: 'Politique de confidentialité',
                external: true,
            },
            {
                id: 'cookies',
                href: 'https://www.iubenda.com/privacy-policy/49318682/cookie-policy',
                label: 'Politique des cookies',
                external: true,
            },
            {
                id: 'ia',
                href: '/ia',
                label: 'Intelligence artificielle',
            },
            {
                id: 'cookies_settings',
                label: 'Paramètres des cookies',
            },
        ],
    ],
    menuSections: [
        {
            id: 'search',
        },
        {
            id: 'brands',
            list: 'brands',
            // title: (
            // defineMessage({ defaultMessage:"Nos médias", description:"Menu section heading" })
            // ),
            cardRatio: 12 / 5,
            columns: 1,
            cardType: 'horizontal',
            presentation: 'grid',
        },
        {
            id: 'authors',
            route: 'authors',
            list: 'authors',
            loading: 'lazy',
            title: defineMessage({
                defaultMessage: 'Tous les auteurs',
                description: 'Menu section heading',
            }),
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
                person: true,
            },
            presentation: 'grid',
            columns: 4,
            cardType: 'vertical',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
        {
            id: 'micromags',
            route: 'micromags',
            title: defineMessage({
                defaultMessage: 'Micromags',
                description: 'Menu section heading',
            }),
            icon: 'micromag',
            list: 'documents',
            loading: 'lazy',
            type: 'micromag',
            query: {
                collection: 'micromag-urbania',
            },
            cardRatio: 'micromag',
            cardType: 'over',
            cardSize: 'small',
            cardWithout: ['type-icon', 'text'],
            presentation: 'grid',
            columns: 3,
            count: 9,
            cardImageLoading: 'lazy',
        },
        {
            id: 'videos',
            route: 'videos',
            title: defineMessage({
                defaultMessage: 'Séries vidéos',
                description: 'Menu section heading',
            }),
            query: {
                type: 'serie',
                placement: ['videos_collections_urbania'],
            },
            presentation: 'grid',
            icon: 'video',
            list: 'collections',
            loading: 'lazy',
            cardType: 'over',
            cardRatio: 'vertical',
            cardWithout: ['text'],
            columns: 3,
            // cardTheme: 'outline',
            // columns: 1,
            count: 6,
            cardImageLoading: 'lazy',
        },
        {
            id: 'podcasts',
            route: 'podcasts',
            title: defineMessage({
                defaultMessage: 'Balados',
                description: 'Menu section heading',
            }),
            query: {
                type: 'serie_podcast',
                placement: ['podcasts_collections_urbania'],
            },
            presentation: 'grid',
            icon: 'podcast',
            list: 'collections',
            loading: 'lazy',
            cardType: 'over',
            cardRatio: 'square',
            cardWithout: ['text'],
            columns: 3,
            // cardTheme: 'outline',
            // columns: 1,
            count: 6,
            cardImageLoading: 'lazy',
        },
        {
            id: 'collections',
            route: 'collections',
            title: defineMessage({
                defaultMessage: 'Collections',
                description: 'Menu section heading',
            }),
            query: {
                order: 'new',
                type: 'collection',
            },
            presentation: 'grid',
            icon: 'collection',
            list: 'collections',
            loading: 'lazy',
            cardType: 'vertical',
            cardSize: 'small',
            cardRatio: 'wide',
            cardTheme: 'rounded',
            cardWith: ['brand-icon'],
            cardWithout: ['surtitle'],
            // cardWithout: ['text'],
            // cardTheme: 'menu',
            // columns: 1,
            count: 6,
            // columns: 1,
            cardImageLoading: 'lazy',
        },
        {
            id: 'categories',
            route: 'categories',
            title: defineMessage({
                defaultMessage: 'Catégories',
                description: 'Menu section heading',
            }),
            icon: 'category',
            list: 'categories',
            presentation: 'inline',
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
            },
            cardType: 'horizontal',
            cardTheme: 'pill',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
        {
            id: 'formats',
            route: 'formats',
            title: defineMessage({
                defaultMessage: 'Formats',
                description: 'Menu section heading',
            }),
            icon: 'format',
            list: 'formats',
            presentation: 'inline',
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
            },
            cardType: 'horizontal',
            cardTheme: 'pill',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
        {
            id: 'topics',
            route: 'topics',
            title: defineMessage({
                defaultMessage: 'Sujets du moment',
                description: 'Menu section heading',
            }),
            icon: 'category',
            list: 'topics',
            presentation: 'inline',
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
            },
            cardType: 'horizontal',
            cardTheme: 'pill',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
    ],
};

export const france: SiteMenus = {
    menuHeader: [
        {
            id: 'don',
            label: 'Faire un don',
            href: '/faire-un-don',
            icon: 'favorite',
        },
    ],
    menuFooter: [
        [
            {
                id: 'a-propos',
                href: '/a-propos',
                label: 'À propos',
            },
            {
                id: 'contact',
                href: '/contact',
                label: 'Contact',
            },
            {
                id: 'publicite',
                href: '/publicite',
                label: 'Publicité',
            },
        ],

        [
            {
                id: 'mentions',
                href: '/mentions-legales',
                label: 'Mentions légales',
            },
            {
                id: 'privacy',
                href: 'https://www.iubenda.com/privacy-policy/49318682',
                label: 'Politique de confidentialité',
                external: true,
            },
            {
                id: 'cookies',
                href: 'https://www.iubenda.com/privacy-policy/49318682/cookie-policy',
                label: 'Politique des cookies',
                external: true,
            },
            {
                id: 'ia',
                href: '/ia',
                label: 'Intelligence artificielle',
            },
            {
                id: 'cookies_settings',
                label: 'Paramètres des cookies',
            },
        ],
    ],
    menuSections: [
        {
            id: 'search',
        },
        {
            id: 'authors',
            route: 'authors',
            list: 'authors',
            loading: 'lazy',
            title: defineMessage({
                defaultMessage: 'Tous les auteurs',
                description: 'Menu section heading',
            }),
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
                person: true,
            },
            presentation: 'grid',
            columns: 4,
            cardType: 'vertical',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
        {
            id: 'micromags',
            route: 'micromags',
            title: defineMessage({
                defaultMessage: 'Micromags',
                description: 'Menu section heading',
            }),
            icon: 'micromag',
            list: 'documents',
            loading: 'lazy',
            type: 'micromag',
            query: {
                collection: 'micromag-france',
            },
            cardRatio: 'micromag',
            cardType: 'over',
            cardSize: 'small',
            cardWithout: ['type-icon', 'text'],
            presentation: 'grid',
            columns: 3,
            count: 9,
            cardImageLoading: 'lazy',
        },
        {
            id: 'videos',
            route: 'videos',
            title: defineMessage({
                defaultMessage: 'Séries vidéos',
                description: 'Menu section heading',
            }),
            query: {
                type: 'serie',
                placement: ['videos_collections_france'],
            },
            presentation: 'grid',
            icon: 'video',
            list: 'collections',
            loading: 'lazy',
            cardType: 'over',
            cardRatio: 'vertical',
            cardWithout: ['text'],
            columns: 3,
            count: 6,
            cardImageLoading: 'lazy',
        },
        {
            id: 'collections',
            route: 'collections',
            title: defineMessage({
                defaultMessage: 'Collections',
                description: 'Menu section heading',
            }),
            query: {
                order: 'new',
                type: 'collection',
            },
            presentation: 'grid',
            icon: 'collection',
            list: 'collections',
            loading: 'lazy',
            cardType: 'over',
            cardSize: 'small',
            cardRatio: 'horizontal',
            cardTheme: null,
            // cardWithout: ['text'],
            count: 6,
            cardImageLoading: 'lazy',
        },
        {
            id: 'categories',
            route: 'categories',
            title: defineMessage({
                defaultMessage: 'Catégories',
                description: 'Menu section heading',
            }),
            icon: 'category',
            list: 'categories',
            presentation: 'inline',
            count: 12,
            query: {
                for: 'documents',
                order: 'count',
            },
            cardType: 'horizontal',
            cardTheme: 'pill',
            cardSize: 'small',
            cardImageLoading: 'lazy',
        },
        // {
        //     id: 'topics',
        //     route: 'topics',
        //     title: (
        //         defineMessage({
        //             defaultMessage:"Sujets du moment"
        //             description:"Menu section heading"
        //         })
        //     ),
        //     icon: 'category',
        //     list: 'topics',
        //     presentation: 'inline',
        //     count: 12,
        //     query: {
        //         for: 'documents',
        //         order: 'count',
        //     },
        //     cardType: 'horizontal',
        //     cardTheme: 'pill',
        //     cardSize: 'small',
        //     cardImageLoading: 'lazy',
        // },
    ],
};
